// import React, { useState, useEffect } from "react";
// import { motion } from "framer-motion";
// import { useNavigate } from "react-router-dom";

// const PrivacyPolicy = () => {
//   const navigate = useNavigate();
//   const [activeSection, setActiveSection] = useState(null);

//   // Scroll to top when component mounts
//   useEffect(() => {
//     window.scrollTo(0, 0);
//   }, []);

//   const sections = [
//     {
//       title: "Information We Collect",
//       icon: "📋",
//       content: "We only collect information that users voluntarily provide, such as: Name (optional), Email address (optional, used for follow-up or support), Feedback or suggestions, Questions submitted through the forum or contact section, Interaction details such as topic category and urgency. No sensitive personal, financial, medical, or biometric information is collected. We do not use cookies, ad trackers, or automated user behavior monitoring tools at this stage."
//     },
//     {
//       title: "How We Use the Information",
//       icon: "⚙️",
//       content: "Your data is used only for: Responding to questions or feedback, Improving clarity and usefulness of platform features, Enhancing spiritual guidance offerings, Internal review and platform development. We do not use your data for advertising, commercial targeting, or automated decision-making that affects you."
//     },
//     {
//       title: "Data Storage & Security",
//       icon: "🔒",
//       content: "Data is stored securely using industry-standard methods. Only authorized team members can access submitted information. We do not share or sell your data to third parties. If required by law, we may disclose data to legal authorities after due verification."
//     },
//     {
//       title: "User Rights",
//       icon: "👤",
//       content: "You have complete control over your data. At any time, you may: Request a copy of your submitted data, Request correction or removal, Request complete deletion of personal entries. You can do this via our Contact Us section or by emailing the platform support."
//     },
//     {
//       title: "No Guarantee of Complete Data Protection",
//       icon: "⚠️",
//       content: "While we use best possible security practices, no digital platform can guarantee complete protection from unauthorized access. By using DharmaAnswers, you acknowledge this risk. We encourage users not to share personal, confidential, or sensitive life details in public forum questions. If needed, use generalized or anonymous wording."
//     },
//     {
//       title: "Use of AI Responses",
//       icon: "🤖",
//       content: "Responses may include insights from AI models integrated with our platform. These AI-generated answers: Are solely for educational and knowledge-sharing purposes, Must not be considered a substitute for professional or legal advice, Are provided based on contextual interpretation of spiritual texts."
//     },
//     {
//       title: "Third-Party Integrations",
//       icon: "🔄",
//       content: "At this stage, DharmaAnswers does not integrate external third-party platforms for data processing (such as analytics or advertising). If added in the future, users will be notified with updated policy terms."
//     },
//     {
//       title: "Future Updates",
//       icon: "📅",
//       content: "This privacy policy may be updated if: New platform features are added (e.g. login system, analytics, subscription services), Legal or regulatory requirements change, Data handling practices evolve. All updates will be reflected on this page with an effective date."
//     },
//     {
//       title: "Contact & Privacy Queries",
//       icon: "📧",
//       content: "For any privacy-related concerns or data access/review requests, contact us through: 📧 YourDefinedEmailID (or the form under Contact Us section). We aim to review and respond within 7 working days."
//     }
//   ];

//   const keyPrinciples = [
//     {
//       title: "Minimal Data Collection",
//       icon: "📊",
//       description: "We only collect what you voluntarily provide - no unnecessary data harvesting"
//     },
//     {
//       title: "No Commercial Use",
//       icon: "🚫",
//       description: "Your data is never used for advertising or sold to third parties"
//     },
//     {
//       title: "Complete User Control",
//       icon: "🎮",
//       description: "You can request access, correction, or deletion of your data anytime"
//     },
//     {
//       title: "Educational Purpose",
//       icon: "🎓",
//       description: "Data is used solely for improving spiritual guidance and platform features"
//     },
//     {
//       title: "Transparent Practices",
//       icon: "🔍",
//       description: "Clear communication about data usage and future changes"
//     },
//     {
//       title: "Respectful Handling",
//       icon: "🙏",
//       description: "Your privacy is treated with the same respect as our spiritual content"
//     }
//   ];

//   const handleGoHome = () => {
//     navigate('/');
//   };

//   return (
//     <div className="min-h-screen bg-gradient-to-br from-gray-900 via-blue-900 to-purple-900 py-8 px-4 sm:px-6 lg:px-8">
//       <div className="max-w-6xl mx-auto">
//         {/* Header with Close Button */}
//         <motion.div
//           initial={{ opacity: 0, y: 20 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ duration: 0.6 }}
//           className="relative text-center mb-12"
//         >
//           {/* Close Button */}
//           <button
//             onClick={handleGoHome}
//             className="absolute top-0 right-0 w-10 h-10 flex items-center justify-center bg-gray-800/50 hover:bg-gray-700/70 backdrop-blur-sm rounded-full border border-gray-700 hover:border-blue-500/50 transition-all duration-300 group"
//             aria-label="Close and go home"
//           >
//             <span className="text-gray-400 group-hover:text-white text-xl font-bold transition-colors duration-300">
//               ×
//             </span>
//           </button>

//           <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-blue-500 to-purple-600 rounded-2xl mb-6 shadow-2xl">
//             <span className="text-2xl">🔒</span>
//           </div>
          
//           <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold bg-gradient-to-r from-blue-400 via-purple-400 to-blue-400 bg-clip-text text-transparent mb-4 font-['Inter'] tracking-tight">
//             Privacy Policy
//           </h1>
          
//           <p className="text-xl lg:text-2xl text-gray-300 max-w-3xl mx-auto mb-4 font-['Inter'] font-light leading-relaxed">
//             Protecting your privacy while sharing ancient wisdom
//           </p>
          
//           <div className="inline-block bg-blue-500/20 border border-blue-500/30 rounded-full px-6 py-2 backdrop-blur-sm">
//             <p className="text-blue-300 text-sm font-medium">Effective Date: Upon public launch</p>
//           </div>
//         </motion.div>

//         {/* Introduction Card - Wider for Desktop */}
//         <motion.div
//           initial={{ opacity: 0, y: 20 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ duration: 0.6, delay: 0.1 }}
//           className="bg-gray-800/50 backdrop-blur-sm rounded-2xl p-6 lg:p-8 mb-8 lg:mb-12 border border-gray-700 max-w-4xl mx-auto"
//         >
//           <div className="space-y-4">
//             <p className="text-gray-300 leading-relaxed text-lg lg:text-xl font-['Inter']">
//               <span className="font-semibold text-blue-400">DharmaAnswers</span> ("we", "our", "platform") is committed to protecting your privacy and handling your data responsibly. This platform is designed primarily for educational and spiritual guidance based on ancient Hindu scriptures interpreted for modern life.
//             </p>
//             <p className="text-gray-300 leading-relaxed text-lg lg:text-xl font-['Inter']">
//               We collect <span className="font-semibold text-blue-400">minimal user data</span> and use it only to improve our services. By using our platform, you agree to the practices described below.
//             </p>
//           </div>
//         </motion.div>

//         {/* Main Content - Full Width Grid for Desktop */}
//         <div className="grid lg:grid-cols-3 gap-8 mb-12">
//           {/* Policy Sections - Takes 2/3 on desktop */}
//           <div className="lg:col-span-2 space-y-6">
//             <motion.div
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.6, delay: 0.2 }}
//               className="bg-gray-800/30 backdrop-blur-sm rounded-2xl p-6 lg:p-8 border border-gray-700"
//             >
//               <h2 className="text-2xl lg:text-3xl font-bold text-white mb-6 lg:mb-8 font-['Inter'] tracking-tight">
//                 Our Privacy Policy Details
//               </h2>
              
//               <div className="space-y-6">
//                 {sections.map((section, index) => (
//                   <motion.div
//                     key={section.title}
//                     initial={{ opacity: 0, x: -20 }}
//                     animate={{ opacity: 1, x: 0 }}
//                     transition={{ duration: 0.5, delay: index * 0.05 }}
//                     className={`bg-gray-800/50 backdrop-blur-sm rounded-xl lg:rounded-2xl p-5 lg:p-6 cursor-pointer transition-all duration-300 border-2 ${
//                       activeSection === index 
//                         ? 'border-blue-500 shadow-2xl shadow-blue-500/20' 
//                         : 'border-gray-700 hover:border-blue-400/30'
//                     }`}
//                     onClick={() => setActiveSection(activeSection === index ? null : index)}
//                   >
//                     <div className="flex items-start gap-4 lg:gap-6">
//                       <div className="flex-shrink-0 w-12 h-12 lg:w-14 lg:h-14 bg-gradient-to-br from-blue-500 to-purple-600 rounded-xl flex items-center justify-center text-white text-lg lg:text-xl">
//                         {section.icon}
//                       </div>
//                       <div className="flex-1">
//                         <h3 className="text-xl lg:text-2xl font-semibold text-white mb-3 lg:mb-4 font-['Inter'] tracking-tight">
//                           {section.title}
//                         </h3>
//                         <p className="text-gray-300 leading-relaxed text-base lg:text-lg font-['Inter']">
//                           {section.content}
//                         </p>
//                       </div>
//                     </div>
//                   </motion.div>
//                 ))}
//               </div>
//             </motion.div>
//           </div>

//           {/* Sidebar with Principles and Final Note - Takes 1/3 on desktop */}
//           <div className="space-y-6 lg:space-y-8">
//             {/* Principles Grid */}
//             <motion.div
//               initial={{ opacity: 0, x: 20 }}
//               animate={{ opacity: 1, x: 0 }}
//               transition={{ duration: 0.6, delay: 0.3 }}
//               className="bg-gray-800/30 backdrop-blur-sm rounded-2xl p-6 lg:p-8 border border-gray-700"
//             >
//               <h2 className="text-2xl lg:text-3xl font-bold text-white mb-6 lg:mb-8 text-center font-['Inter'] tracking-tight">
//                 Our Privacy Principles
//               </h2>
              
//               <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-1 gap-4 lg:gap-6">
//                 {keyPrinciples.map((principle, index) => (
//                   <motion.div
//                     key={principle.title}
//                     initial={{ opacity: 0, y: 20 }}
//                     animate={{ opacity: 1, y: 0 }}
//                     transition={{ duration: 0.5, delay: 0.1 * index }}
//                     className="bg-gray-800/50 rounded-xl lg:rounded-2xl p-4 lg:p-5 border border-gray-700 hover:border-blue-500/30 transition-all duration-300 hover:transform hover:scale-[1.02]"
//                   >
//                     <div className="flex items-start gap-3 lg:gap-4">
//                       <div className="flex-shrink-0 w-10 h-10 lg:w-12 lg:h-12 bg-blue-500/20 rounded-lg lg:rounded-xl flex items-center justify-center text-blue-400 text-lg lg:text-xl">
//                         {principle.icon}
//                       </div>
//                       <div>
//                         <h4 className="font-semibold text-white mb-2 text-base lg:text-lg font-['Inter']">
//                           {principle.title}
//                         </h4>
//                         <p className="text-gray-300 text-sm lg:text-base font-['Inter'] leading-relaxed">
//                           {principle.description}
//                         </p>
//                       </div>
//                     </div>
//                   </motion.div>
//                 ))}
//               </div>

//               {/* Data Protection Notice */}
//               <motion.div
//                 initial={{ opacity: 0, y: 20 }}
//                 animate={{ opacity: 1, y: 0 }}
//                 transition={{ duration: 0.6, delay: 0.6 }}
//                 className="mt-8 pt-6 border-t border-gray-700"
//               >
//                 <div className="flex items-start gap-3 lg:gap-4">
//                   <div className="flex-shrink-0 w-10 h-10 lg:w-12 lg:h-12 bg-yellow-500/20 rounded-lg lg:rounded-xl flex items-center justify-center text-yellow-400 text-lg lg:text-xl">
//                     ⚠️
//                   </div>
//                   <div>
//                     <h4 className="font-semibold text-white mb-2 text-base lg:text-lg font-['Inter']">
//                       Important Notice
//                     </h4>
//                     <p className="text-gray-300 text-sm lg:text-base font-['Inter'] leading-relaxed">
//                       This privacy policy applies to DharmaAnswers only. For spiritual practices, rituals, or personal guidance, please consult qualified experts in accordance with your tradition.
//                     </p>
//                   </div>
//                 </div>
//               </motion.div>
//             </motion.div>

//             {/* Final Note Card */}
//             <motion.div
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.6, delay: 0.8 }}
//               className="bg-gradient-to-br from-blue-500/10 via-purple-500/10 to-blue-500/10 backdrop-blur-sm rounded-2xl p-6 lg:p-8 border border-blue-500/30"
//             >
//               <div className="flex items-start gap-4 lg:gap-6">
//                 <div className="flex-shrink-0 w-12 h-12 lg:w-14 lg:h-14 bg-gradient-to-br from-blue-500 to-purple-600 rounded-xl flex items-center justify-center text-white text-lg lg:text-xl">
//                   💫
//                 </div>
//                 <div>
//                   <h3 className="text-xl lg:text-2xl font-semibold text-white mb-3 lg:mb-4 font-['Inter'] tracking-tight">
//                     Final Note
//                   </h3>
//                   <p className="text-gray-300 leading-relaxed mb-4 lg:mb-6 text-base lg:text-lg font-['Inter']">
//                     By interacting with DharmaAnswers, you consent to responsible use of your voluntarily submitted data in alignment with the spiritual, educational, and non-commercial purpose of this platform. No personal data is harvested beyond what you provide.
//                   </p>
//                   <blockquote className="border-l-4 border-blue-500 pl-4 lg:pl-6 py-2 lg:py-3 italic text-gray-300 text-base lg:text-lg font-['Inter'] leading-relaxed">
//                     "This platform is built with sincerity and respect for personal privacy and sacred knowledge. Your trust is valued, and your information is handled with utmost responsibility."
//                   </blockquote>
//                 </div>
//               </div>
//             </motion.div>
//           </div>
//         </div>

//         {/* Bottom CTA - Full Width */}
//         <motion.div
//           initial={{ opacity: 0, y: 20 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ duration: 0.6, delay: 1 }}
//           className="text-center"
//         >
//           <div className="bg-gradient-to-r from-blue-500/20 via-purple-500/20 to-blue-500/20 backdrop-blur-sm rounded-2xl p-6 lg:p-10 border border-blue-500/30 max-w-4xl mx-auto">
//             <h3 className="text-2xl lg:text-3xl font-bold text-white mb-4 lg:mb-6 font-['Inter'] tracking-tight">
//               Have Questions About Your Privacy?
//             </h3>
//             <p className="text-gray-300 mb-6 lg:mb-8 max-w-2xl mx-auto text-lg lg:text-xl font-['Inter'] leading-relaxed">
//               We're here to help. Reach out to us for any privacy-related concerns or to exercise your data rights.
//             </p>
//             <button 
//               onClick={() => navigate('/contact')}
//               className="px-8 lg:px-12 py-3 lg:py-4 bg-gradient-to-r from-blue-600 to-purple-600 text-white font-semibold rounded-xl lg:rounded-2xl hover:opacity-90 transition-all duration-300 transform hover:scale-105 text-lg lg:text-xl shadow-lg shadow-blue-500/30"
//             >
//               Contact Privacy Team
//             </button>
            
//             {/* Additional Info */}
//             <div className="mt-8 pt-6 lg:pt-8 border-t border-gray-700/50">
//               <div className="flex flex-col lg:flex-row justify-center items-center gap-4 lg:gap-8">
//                 <div className="flex items-center gap-2">
//                   <div className="w-8 h-8 bg-green-500/20 rounded-lg flex items-center justify-center text-green-400">
//                     ✅
//                   </div>
//                   <span className="text-gray-300 text-sm lg:text-base font-['Inter']">
//                     Fully Compliant
//                   </span>
//                 </div>
//                 <div className="flex items-center gap-2">
//                   <div className="w-8 h-8 bg-blue-500/20 rounded-lg flex items-center justify-center text-blue-400">
//                     📚
//                   </div>
//                   <span className="text-gray-300 text-sm lg:text-base font-['Inter']">
//                     Educational Focus
//                   </span>
//                 </div>
//                 <div className="flex items-center gap-2">
//                   <div className="w-8 h-8 bg-purple-500/20 rounded-lg flex items-center justify-center text-purple-400">
//                     🔄
//                   </div>
//                   <span className="text-gray-300 text-sm lg:text-base font-['Inter']">
//                     Regular Updates
//                   </span>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </motion.div>

//         {/* Back to Top Button */}
//         <motion.button
//           initial={{ opacity: 0 }}
//           animate={{ opacity: 1 }}
//           transition={{ duration: 0.6, delay: 1.2 }}
//           onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
//           className="fixed bottom-6 right-6 lg:bottom-8 lg:right-8 w-12 h-12 lg:w-14 lg:h-14 flex items-center justify-center bg-gray-800/80 backdrop-blur-sm rounded-full border border-gray-700 hover:border-blue-500/50 hover:bg-gray-700/80 transition-all duration-300 shadow-lg z-50 group"
//           aria-label="Scroll to top"
//         >
//           <span className="text-gray-400 group-hover:text-blue-400 text-xl lg:text-2xl font-bold transition-colors duration-300">
//             ↑
//           </span>
//         </motion.button>
//       </div>
//     </div>
//   );
// };

// export default PrivacyPolicy;











import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useNavigate } from "react-router-dom";

const PrivacyPolicy = () => {
  const navigate = useNavigate();
  const [activeSection, setActiveSection] = useState(null);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    const handleScroll = () => setScrolled(window.scrollY > 100);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const sections = [
    {
      title: "Information We Collect",
      icon: "📋",
      color: "#61dafb",
      content:
        "We only collect information that users voluntarily provide — such as name (optional), email (optional), feedback, submitted questions, and topic category. No sensitive personal, financial, medical, or biometric data is collected. We do not use cookies, ad trackers, or automated behavior monitoring at this stage.",
    },
    {
      title: "How We Use Your Information",
      icon: "⚙️",
      color: "#a78bfa",
      content:
        "Your data is used only for responding to questions or feedback, improving platform clarity and usefulness, enhancing spiritual guidance offerings, and internal development. We never use your data for advertising, commercial targeting, or automated decision-making that affects you.",
    },
    {
      title: "Data Storage & Security",
      icon: "🔒",
      color: "#34d399",
      content:
        "Data is stored securely using industry-standard methods. Only authorized team members can access submitted information. We do not share or sell your data to third parties. If required by law, we may disclose data to legal authorities after due verification.",
    },
    {
      title: "Your Rights",
      icon: "👤",
      color: "#fbbf24",
      content:
        "You have complete control over your data. At any time, you may request a copy of your submitted data, request correction or removal, or request complete deletion of personal entries. Contact us via the Contact Us section or platform support email.",
    },
    {
      title: "No Complete Protection Guarantee",
      icon: "⚠️",
      color: "#f87171",
      content:
        "While we use best possible security practices, no digital platform can guarantee complete protection from unauthorized access. By using DharmaAnswers, you acknowledge this risk. We encourage users not to share sensitive personal details in public forum questions.",
    },
    {
      title: "AI-Generated Responses",
      icon: "🤖",
      color: "#818cf8",
      content:
        "Responses may include insights from AI models integrated with our platform. These AI-generated answers are solely for educational and knowledge-sharing purposes, must not be considered a substitute for professional advice, and are based on contextual interpretation of spiritual texts.",
    },
    {
      title: "Third-Party Integrations",
      icon: "🔄",
      color: "#06b6d4",
      content:
        "DharmaAnswers currently does not integrate external third-party platforms for data processing such as analytics or advertising. If added in the future, users will be notified with updated policy terms.",
    },
    {
      title: "Intellectual Property",
      icon: "🛡️",
      color: "#f59e0b",
      content:
        "DharmaAnswers is an original concept created and developed by Krishna Kumar, starting November 2025, first deployed January 2026. The platform's design, structure, feature set, and core concept are proprietary. Unauthorized reproduction, copying, or commercial use of this platform's concept or implementation is not permitted without explicit written consent.",
    },
    {
      title: "Future Updates",
      icon: "📅",
      color: "#a3e635",
      content:
        "This privacy policy may be updated if new platform features are added, legal or regulatory requirements change, or data handling practices evolve. All updates will be reflected on this page with an effective date. Users are encouraged to review periodically.",
    },
    {
      title: "Contact & Privacy Queries",
      icon: "📧",
      color: "#fb7185",
      content:
        "For any privacy-related concerns, data access requests, or intellectual property queries, contact us through the Contact Us section. We aim to review and respond within 7 working days.",
    },
  ];

  const principles = [
    { icon: "📊", title: "Minimal Collection", desc: "Only what you voluntarily provide", color: "#61dafb" },
    { icon: "🚫", title: "No Commercial Use", desc: "Never sold or used for ads", color: "#a78bfa" },
    { icon: "🎮", title: "User Control", desc: "Access, edit, or delete anytime", color: "#34d399" },
    { icon: "🎓", title: "Educational Focus", desc: "Data used only to improve guidance", color: "#fbbf24" },
    { icon: "🔍", title: "Transparent", desc: "Clear communication always", color: "#f87171" },
    { icon: "🛡️", title: "IP Protected", desc: "Original concept, all rights reserved", color: "#818cf8" },
  ];

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(160deg, #04040f 0%, #080818 50%, #0a0612 100%)",
        fontFamily: "'Crimson Pro', Georgia, serif",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Decorative orbs */}
      <div style={{
        position: "fixed", top: "-200px", right: "-200px",
        width: "500px", height: "500px", borderRadius: "50%",
        background: "radial-gradient(circle, rgba(97,218,251,0.04) 0%, transparent 70%)",
        pointerEvents: "none", zIndex: 0,
      }} />
      <div style={{
        position: "fixed", bottom: "-200px", left: "-200px",
        width: "500px", height: "500px", borderRadius: "50%",
        background: "radial-gradient(circle, rgba(167,139,250,0.04) 0%, transparent 70%)",
        pointerEvents: "none", zIndex: 0,
      }} />

      {/* Back to top */}
      <AnimatePresence>
        {scrolled && (
          <motion.button
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.8 }}
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            style={{
              position: "fixed", bottom: "32px", right: "32px", zIndex: 100,
              width: "48px", height: "48px", borderRadius: "50%",
              background: "rgba(97,218,251,0.1)",
              border: "1px solid rgba(97,218,251,0.3)",
              color: "#61dafb", fontSize: "20px", cursor: "pointer",
              display: "flex", alignItems: "center", justifyContent: "center",
              backdropFilter: "blur(10px)",
            }}
          >
            ↑
          </motion.button>
        )}
      </AnimatePresence>

      <div style={{ position: "relative", zIndex: 1, maxWidth: "1100px", margin: "0 auto", padding: "60px 24px" }}>

        {/* ── HEADER ── */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          style={{ textAlign: "center", marginBottom: "72px", position: "relative" }}
        >
          <motion.div
            animate={{ y: [0, -6, 0] }}
            transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
            style={{
              display: "inline-flex", alignItems: "center", justifyContent: "center",
              width: "90px", height: "90px", borderRadius: "24px",
              background: "linear-gradient(135deg, rgba(97,218,251,0.15), rgba(167,139,250,0.15))",
              border: "1px solid rgba(97,218,251,0.25)",
              fontSize: "40px", marginBottom: "28px",
              boxShadow: "0 0 40px rgba(97,218,251,0.15)",
            }}
          >
            🔒
          </motion.div>

          <h1 style={{
            fontSize: "clamp(2.2rem, 5vw, 4rem)",
            fontWeight: "700",
            background: "linear-gradient(135deg, #61dafb 0%, #a78bfa 100%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            marginBottom: "16px",
            fontFamily: "'Cinzel', Georgia, serif",
            letterSpacing: "-0.5px",
          }}>
            Privacy Policy
          </h1>

          <p style={{ color: "#64748b", fontSize: "1rem", fontFamily: "monospace", marginBottom: "24px" }}>
            Effective Date: January 2026 · Development started: November 2025
          </p>

          {/* IP notice badge */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.5 }}
            style={{
              display: "inline-flex", alignItems: "center", gap: "8px",
              padding: "10px 20px",
              background: "rgba(251,191,36,0.08)",
              border: "1px solid rgba(251,191,36,0.2)",
              borderRadius: "50px",
            }}
          >
            <span style={{ fontSize: "16px" }}>🛡️</span>
            <span style={{ color: "#fbbf24", fontSize: "13px", fontFamily: "monospace" }}>
              © 2025–2026 DharmaAnswers — Original concept by Krishna Kumar — All rights reserved
            </span>
          </motion.div>
        </motion.div>

        {/* ── INTRO CARD ── */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
          style={{
            background: "rgba(255,255,255,0.02)",
            border: "1px solid rgba(97,218,251,0.15)",
            borderRadius: "20px",
            padding: "36px 40px",
            marginBottom: "60px",
            position: "relative",
            overflow: "hidden",
          }}
        >
          <div style={{
            position: "absolute", top: 0, left: 0, right: 0, height: "2px",
            background: "linear-gradient(90deg, transparent, #61dafb, #a78bfa, transparent)",
          }} />
          <p style={{ color: "#94a3b8", lineHeight: 1.9, fontSize: "1.1rem", marginBottom: "16px" }}>
            <span style={{ color: "#61dafb", fontWeight: "600" }}>DharmaAnswers</span> is committed to protecting your privacy and handling your data responsibly. This platform is designed primarily for educational and spiritual guidance based on authentic Hindu scriptures interpreted for modern life.
          </p>
          <p style={{ color: "#94a3b8", lineHeight: 1.9, fontSize: "1.1rem" }}>
            We collect <span style={{ color: "#61dafb", fontWeight: "600" }}>minimal user data</span> and use it only to improve our services. DharmaAnswers is an <span style={{ color: "#fbbf24", fontWeight: "600" }}>original concept</span> and its design, structure, and implementation are proprietary intellectual property.
          </p>
        </motion.div>

        {/* ── PRINCIPLES ── */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
          style={{ marginBottom: "60px" }}
        >
          <h2 style={{ textAlign: "center", color: "#64748b", fontSize: "0.85rem", letterSpacing: "4px", textTransform: "uppercase", marginBottom: "32px", fontFamily: "monospace" }}>
            Our Core Principles
          </h2>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))", gap: "12px" }}>
            {principles.map((p, i) => (
              <motion.div
                key={p.title}
                initial={{ opacity: 0, y: 16 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.05 * i }}
                whileHover={{ y: -3 }}
                style={{
                  background: "rgba(255,255,255,0.02)",
                  border: `1px solid rgba(255,255,255,0.07)`,
                  borderRadius: "14px",
                  padding: "20px 16px",
                  textAlign: "center",
                  transition: "all 0.2s",
                }}
              >
                <div style={{ fontSize: "24px", marginBottom: "10px" }}>{p.icon}</div>
                <div style={{ color: p.color, fontSize: "12px", fontWeight: "700", marginBottom: "6px", fontFamily: "monospace" }}>{p.title}</div>
                <div style={{ color: "#475569", fontSize: "12px", lineHeight: 1.5 }}>{p.desc}</div>
              </motion.div>
            ))}
          </div>
        </motion.div>

        {/* ── POLICY SECTIONS ── */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4 }}
          style={{ marginBottom: "60px" }}
        >
          <h2 style={{ textAlign: "center", color: "#64748b", fontSize: "0.85rem", letterSpacing: "4px", textTransform: "uppercase", marginBottom: "32px", fontFamily: "monospace" }}>
            Policy Details
          </h2>
          <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
            {sections.map((section, index) => (
              <motion.div
                key={section.title}
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: 0.05 * index }}
                onClick={() => setActiveSection(activeSection === index ? null : index)}
                style={{
                  background: activeSection === index ? "rgba(255,255,255,0.04)" : "rgba(255,255,255,0.02)",
                  border: `1px solid ${activeSection === index ? section.color + "40" : "rgba(255,255,255,0.06)"}`,
                  borderRadius: "16px",
                  padding: "20px 24px",
                  cursor: "pointer",
                  transition: "all 0.3s ease",
                }}
              >
                <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
                  <div style={{
                    width: "40px", height: "40px", borderRadius: "12px", flexShrink: 0,
                    background: `${section.color}15`,
                    border: `1px solid ${section.color}30`,
                    display: "flex", alignItems: "center", justifyContent: "center",
                    fontSize: "18px",
                  }}>
                    {section.icon}
                  </div>
                  <div style={{ flex: 1 }}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                      <h3 style={{
                        color: activeSection === index ? section.color : "#cbd5e1",
                        fontSize: "1rem", fontWeight: "600",
                        fontFamily: "'Cinzel', Georgia, serif",
                        transition: "color 0.3s",
                      }}>
                        {section.title}
                      </h3>
                      <span style={{ color: "#475569", fontSize: "18px", transition: "transform 0.3s", transform: activeSection === index ? "rotate(180deg)" : "none" }}>
                        ⌄
                      </span>
                    </div>
                    <AnimatePresence>
                      {activeSection === index && (
                        <motion.p
                          initial={{ opacity: 0, height: 0, marginTop: 0 }}
                          animate={{ opacity: 1, height: "auto", marginTop: "12px" }}
                          exit={{ opacity: 0, height: 0, marginTop: 0 }}
                          style={{ color: "#94a3b8", fontSize: "0.95rem", lineHeight: 1.8, overflow: "hidden" }}
                        >
                          {section.content}
                        </motion.p>
                      )}
                    </AnimatePresence>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </motion.div>

        {/* ── FINAL NOTE ── */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.6 }}
          style={{
            background: "linear-gradient(135deg, rgba(97,218,251,0.06), rgba(167,139,250,0.06))",
            border: "1px solid rgba(97,218,251,0.2)",
            borderRadius: "20px",
            padding: "40px",
            marginBottom: "48px",
            textAlign: "center",
            position: "relative",
            overflow: "hidden",
          }}
        >
          <div style={{
            position: "absolute", bottom: 0, left: 0, right: 0, height: "2px",
            background: "linear-gradient(90deg, transparent, #a78bfa, #61dafb, transparent)",
          }} />
          <div style={{ fontSize: "32px", marginBottom: "16px" }}>💫</div>
          <p style={{ color: "#94a3b8", lineHeight: 1.9, fontSize: "1.05rem", fontStyle: "italic", maxWidth: "700px", margin: "0 auto 24px" }}>
            "By interacting with DharmaAnswers, you consent to responsible use of your voluntarily submitted data in alignment with the spiritual, educational, and non-commercial purpose of this platform."
          </p>
          <button
            onClick={() => navigate("/contact")}
            style={{
              padding: "12px 32px",
              background: "linear-gradient(135deg, #61dafb, #a78bfa)",
              color: "#000",
              border: "none",
              borderRadius: "50px",
              fontSize: "14px",
              fontWeight: "700",
              cursor: "pointer",
              fontFamily: "monospace",
              letterSpacing: "1px",
              transition: "all 0.3s",
            }}
            onMouseEnter={(e) => e.target.style.opacity = "0.85"}
            onMouseLeave={(e) => e.target.style.opacity = "1"}
          >
            CONTACT PRIVACY TEAM →
          </button>
        </motion.div>

        {/* ── COPYRIGHT FOOTER ── */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.7 }}
          style={{ textAlign: "center", padding: "24px 0" }}
        >
          <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "8px", flexWrap: "wrap" }}>
            <span style={{ color: "#334155", fontSize: "13px", fontFamily: "monospace" }}>© 2025–2026 DharmaAnswers</span>
            <span style={{ color: "#1e293b" }}>·</span>
            <span style={{ color: "#334155", fontSize: "13px", fontFamily: "monospace" }}>
              Original concept & development by <span style={{ color: "#61dafb" }}>Krishna Kumar</span>
            </span>
            <span style={{ color: "#1e293b" }}>·</span>
            <span style={{ color: "#334155", fontSize: "13px", fontFamily: "monospace" }}>All rights reserved</span>
            <span style={{ color: "#1e293b" }}>·</span>
            <span style={{ color: "#334155", fontSize: "13px", fontFamily: "monospace" }}>v1.3.0</span>
          </div>
        </motion.div>

      </div>

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Cinzel:wght@400;600;700&family=Crimson+Pro:ital,wght@0,400;0,600;1,400&display=swap');
      `}</style>
    </div>
  );
};

export default PrivacyPolicy;